var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.024 5.46c.172-.951 1.096-1.722 2.062-1.722h16.426c.966 0 1.61.77 1.437 1.722l-3.827 21.08c-.172.951-1.096 1.722-2.062 1.722H5.634c-.966 0-1.61-.77-1.437-1.722L8.024 5.46z",
    fill: "#fff",
    stroke: "#9CACC0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.728 7.643h5.804M10.234 10.458h10.159",
    stroke: "#9CACC0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CBBF0",
    d: "M8.593 19.473h13.165l-.362 1.994H8.231zM8.016 22.797h13.165l-.362 1.994H7.654zM9.215 16.149H22.38l-.362 1.994H8.853z"
  })));
}
export default SvgCaseList;